<template>

  <div>
    <!--div v-if="totalElements === -1" class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div-->

    <div v-if="totalElements === 0">
      <!-- show nothing -->
    </div>

    <div v-else>
      <div class="row">

        <div class="col-sm-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button :class="['nav-link', { active: activeTab === 'home' }]" id="home-tab" @click="setActiveTab('home')" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" :aria-selected="activeTab === 'home'"><i class="fa-solid fa-chart-bar"></i> {{ $t("Activitats docents per data") }}</button>
            </li>
            <li class="nav-item" role="presentation">
              <button :class="['nav-link', { active: activeTab === 'profile' }]" id="profile-tab" @click="setActiveTab('profile')" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" :aria-selected="activeTab === 'profile'"><i class="fa-solid fa-chart-pie"></i> {{ $t("Activitats docents per tipus") }}</button>
            </li>
            <li class="nav-item" role="presentation">
              <button :class="['nav-link', { active: activeTab === 'blocks' }]" id="blocks-tab" @click="setActiveTab('blocks')" data-bs-toggle="tab" data-bs-target="#blocks" type="button" role="tab" aria-controls="blocks" :aria-selected="activeTab === 'blocks'"><i class="fa-solid fa-chart-diagram"></i> {{ $t("Activitats docents per ambit") }}</button>
            </li>
            <li class="nav-item" role="presentation" v-show="showTreballsFinals">
              <button :class="['nav-link', { active: activeTab === 'radar' }]" id="radar-tab" @click="setActiveTab('radar')" data-bs-toggle="tab" data-bs-target="#radar" type="button" role="tab" aria-controls="radar" :aria-selected="activeTab === 'radar'"><i class="fa-solid fa-microchip"></i> {{ $t("innovation_radar.title") }}</button>
            </li>
            <!--li class="nav-item" role="presentation">
              <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false"><i class="fa-solid fa-chart-area"></i> {{ $t("Contingut docent per condicions dacces") }}</button>
            </li-->
          </ul>
          <div class="tab-content mt-4 mb-5" id="myTabContent">

            <!--div class="alert alert-danger mt-5" role="alert">
              <pre>{{ JSON.stringify(response.facetes, null, 4) }}</pre>
            </div-->
            <div :class="['tab-pane', 'fade', { 'show active': activeTab === 'home' }]" id="home" role="tabpanel" aria-labelledby="home-tab">
              <chart-by-data :facetes="response.facetes" :facetes-pivot="response.facetes_pivot" @apply-filter="handleApplyFilter"></chart-by-data>
            </div>
            <div :class="['tab-pane', 'fade', { 'show active': activeTab === 'profile' }]" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <chart-by-type :facetes="response.facetes" @apply-filter="handleApplyFilter"></chart-by-type>
            </div>
            <div :class="['tab-pane', 'fade', { 'show active': activeTab === 'blocks' }]" id="blocks" role="tabpanel" aria-labelledby="blocks-tab">
              <chart-by-type-blocks :facetes="response.facetes" @apply-filter="handleApplyFilter"></chart-by-type-blocks>
            </div>
            <div :class="['tab-pane', 'fade', { 'show active': activeTab === 'radar' }]" id="radar" role="tabpanel" aria-labelledby="radar-tab">
              <innovation-radar-chart :center-id="centerId" :year="year"></innovation-radar-chart>
            </div>

            <!--div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
              <chart-by-data-and-access :facetes="response.facetes" :facetes-pivot="response.facetes_pivot" @apply-filter="handleApplyFilter"></chart-by-data-and-access>
            </div-->
          </div>

        </div>

      </div>

      <div class="row">

      <div class="col-sm-12 col-md-8" >

        <h2>{{ $t("Activitats") }}</h2>

        <div class="row">
          <div class="col-sm-12 col-md-8">

            <PaginationTable
                class="container"
                :show-pagination="true"
                v-model:current-page="currentPage"
                v-model:page-size="pageSize"
                :total="totalElements"
                :handle-current-change="handleCurrentChange">
            </PaginationTable>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-control-sm">
              <div class="d-flex align-items-center justify-content-end">
                <label class="form-check-label me-1" for="selectOrderBy">{{ $t("Ordenació") }}:</label>
                <select class="form-select form-select-sm select-auto-width" @change="handleOrderChange(selectedOrder)" v-model="selectedOrder" id="selectOrderBy">
                  <option value="data asc, activitat_data_available asc">{{ $t('data') }} asc.</option>
                  <option value="data desc, activitat_data_available desc">{{ $t('data') }} desc.</option>
                  <!--option value="activitat_titol asc">{{ $t('titol') }} asc.</option>
                  <option value="activitat_titol desc">{{ $t('titol') }} desc.</option-->
                </select>
              </div>
            </div>
          </div>
        </div>

        <ListActivitats :materials="response.materials" class="mb-4"></ListActivitats>

        <PaginationTable
            class="container"
            :show-pagination="false"
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :total="totalElements"
            :handle-current-change="handleCurrentChange">
        </PaginationTable>

      </div>

      <div v-if="response.facetes" id="filtres" class="col-sm-12 col-md-4 mt-0">
        <FacetesFilter2 :data="response.facetes"  @apply-filter="handleApplyFilter" :split-index="6" :split-index2="13"></FacetesFilter2>
      </div>

    </div>
    </div>
  </div>

</template>

<script>


import {imageUrlAlt} from "@/utils/utils";
import PaginationTable from "@/components/PaginationTable.vue";
import {
  createHandleApplyFilter,
  createHandleCurrentChange,
  createHandleOrderChange,
  getMaterials
} from "@/composables/pageFunctions";
import router from "@/router";
import store from "@/store";
import {usePageWatcher, useSortWatcher} from "@/composables/useWatchers";
import {computed, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import FacetesFilter2 from "@/components/FacetesFilter2.vue";
import ListActivitats from "@/components/ListActivitats.vue";
//import ChartByDataAndAccess from "@/components/charts/ChartByDataAndAccess.vue";
import ChartByType from "@/components/charts/ChartByType.vue";
import ChartByData from "@/components/charts/ChartByData.vue";
import ChartByTypeBlocks from "@/components/charts/ChartByTypeBlocks.vue";
import InnovationRadarChart from "@/components/charts/InnovationRadarChart.vue";

export default {

  name: "MaterialsCommon",
  methods: {imageUrlAlt},
  components: {
    ListActivitats,
    ChartByData,
    ChartByType,
    ChartByTypeBlocks,
    InnovationRadarChart,
    //ChartByDataAndAccess,
    FacetesFilter2,
    PaginationTable
  },
  props: {
    initQuery: {
      type: String,
      required: true,
    },
    routerName: {
      type: String,
      required: true,
    },
    showTreballsFinals: {
      type: Boolean,
      required: false,
      default: false,
    },
    centerId: {
      type: String,
      required: false,
    },
    year: {
      type: [String, Number],
      required: false,
      default: 2025
    },
  },
    setup(props, { emit }) {
      const response = ref([]);
      const route = useRoute();
      const activeTab = ref('home');

      const query = ref(props.initQuery)
      const currentPage = ref(1);
      const totalElements = ref(-1)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("data desc, activitat_data_available desc");
      //const selectedOrder = ref("data desc");

      const setActiveTab = (tabName) => {
        activeTab.value = tabName;
        window.location.hash = '#' + tabName;
      };

      const initializeTabFromHash = () => {
        const hash = route.hash.replace('#', '');
        if (hash && ['home', 'profile', 'blocks', 'radar'].includes(hash)) {
          activeTab.value = hash;
        } else {
          activeTab.value = 'home';
        }
      };

      onMounted(async () => {
        console.log('showTreballsFinals:', props.showTreballsFinals)
        currentPage.value = parseInt(route.params.page) || 1;
        route.params.sort = route.params.sort || selectedOrder.value
        //selectedOrder.value = route.params.sort || selectedOrder.value;
        const result = await getMaterials(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query)
        response.value = result
        totalElements.value = result.total
        emit('updateActivitatCount', totalElements.value);

        // Inicializar pestaña desde el hash de la URL
        initializeTabFromHash();
      });

      // Watcher para cambios en el hash de la URL
      watch(() => route.hash, () => {
        initializeTabFromHash();
      });

      const handleCurrentChange = createHandleCurrentChange(props.routerName, router, route);
      const handleOrderChange = createHandleOrderChange(props.routerName, router, route, currentPage);

      const handleApplyFilter = async (newQuery) => {
        await createHandleApplyFilter({
          newQuery,
          callFunction: getMaterials,
          currentPage,
          query,
          initQuery: props.initQuery,
          response,
          totalElements,
          route,
          store
        });
      };

      // Configure watchers: for 'page' parameter, and 'sort' parameter
      usePageWatcher(getMaterials, currentPage, response, totalElements, query, route, store);
      useSortWatcher(getMaterials, currentPage, response, totalElements, query, route, store);

      return {
        response,
        currentPage,
        totalElements,
        pageSize,
        selectedOrder,
        activeTab,
        setActiveTab,

        handleCurrentChange,
        handleOrderChange,
        handleApplyFilter,

      }
    }
}
</script>

<style scoped>
button:hover {
  text-decoration: underline;
}
</style>

